import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api, ErroApi } from '../lib/api';
import { Alerta, Botao, Campo, Cartao } from '../componentes/Interface';

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [senha, setSenha] = useState('');
  const [repetir, setRepetir] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const navegar = useNavigate();

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    if (senha !== repetir) {
      setErro('As duas senhas precisam ser iguais.');
      return;
    }
    setEnviando(true);
    try {
      await api('/auth/redefinir', { method: 'POST', body: JSON.stringify({ token, senha }) });
      navegar('/login', { replace: true });
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui alterar a senha.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center">
          <img src="/logo-fundo.png" alt="Sara Osasco" className="h-20 w-20 rounded-2xl object-cover shadow-cartao" />
          <h1 className="mt-3 text-xl font-semibold text-tinta-900">Criar nova senha</h1>
        </div>
        <Cartao>
          {!token ? (
            <div className="space-y-4">
              <Alerta>Link incompleto. Peca um novo em "Esqueci minha senha".</Alerta>
              <Link to="/esqueci-senha" className="block text-center text-sm text-tinta-900 hover:underline">
                Pedir novo link
              </Link>
            </div>
          ) : (
            <form onSubmit={enviar} className="space-y-4">
              {erro && <Alerta>{erro}</Alerta>}
              <Campo
                rotulo="Nova senha"
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
              />
              <Campo
                rotulo="Repita a nova senha"
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={repetir}
                onChange={(e) => setRepetir(e.target.value)}
              />
              <p className="text-xs text-tinta-400">Pelo menos 8 caracteres.</p>
              <Botao type="submit" carregando={enviando} className="w-full">
                Salvar senha
              </Botao>
            </form>
          )}
        </Cartao>
      </div>
    </div>
  );
}
